<footer class="main-footer">
  <div class="footer-contact">
    <h5>TEM ALGUMA QUESTÃO?</h5>
    <div class="cards-contact">
      <a href="mailto:apoio_local@stihl.pt" target="_blank" class="link-dark">
        <div class="ico-footer"><img src="assets/images/icons/ico_letter.svg" /></div>
        <div class="card-text">ESCREVA-NOS</div>
      </a>
      <div class="card-email" (click)="helpEmail()" data-bs-toggle="tooltip" data-bs-placement="top" title="Cópia de"><span class="help-email">apoio_local@stihl.pt</span><button><fa-icon [icon]="['fas','clone']"></fa-icon></button></div>
    </div>
    
    <div class="hours">Horário de atendimento de segunda a quinta-feira das 8:30 h às 13:00 h e das 14:00 h às 17:00 h. Sexta-feira das 08:00 h às 14:00 h.</div>
  </div>
  <div class="footer_legal">
    <div class="copy">© ANDREAS STIHL, S.A.</div>
    <div *ngIf="isInDevEnvironment" class="position-relative flex-grow-1 text-center">
      <label class="position-absolute top-0 start-50 translate-middle text-nowrap mt-n1">[Solo visible en desarrollo]</label>
      <a href="/develop/patterns" target="_blank" class="link-dark">
        Sistema diseño
      </a>
      -
      <a (click)="toggleDevStyleClass()" target="_blank" class="link-dark">
        Aplicar estilos desarrollo
      </a>
    </div>
    <div>
      <a href="https://blobstihlportugal.blob.core.windows.net/prod-stihl-pt-public/Legal/ES_NOTA_LEGAL_UTILIZACAO_PLATAFORMA_STIHL_LOCAL_PLUS.pdf" target="_blank" class="link-dark">
        NOTA LEGAL
      </a>
    </div>

  </div>
</footer>